import React, { useEffect, useState } from "react";
import styled from "styled-components";
import db from "../../firebase.config";
import { getDocs, query, collection, orderBy } from "firebase/firestore";
import { COLOR_BLUE, COLOR_GREEN, COLOR_WHITE } from "../../constants/colors";
import { PressInterface } from "../../interfaces/press";
import { PRESS_COLLECTION } from "../../constants/firestoreCollection";
import { monthString } from "../../utils/date";
import { CONTACT } from "../../constants/menu";
import ModalSlideshow from "../../components/modalSlideshow";

const Wrapper = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 25px auto 64px auto;
`;

const Title = styled.h1`
  color: ${COLOR_BLUE};
  margin-bottom: 64px;
`;

const PressArea = styled.div`
  margin-bottom: 32px;
`;

const PressItem = styled.div`
  max-width: 320px;
  cursor: pointer;
`;

interface PressLogoInterface {
  logo: string;
}

const PressLogo = styled.div<PressLogoInterface>`
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${(props) => props.logo});
  height: 200px;
  background-color: white;
`;

const PressText = styled.p`
  text-align: center;
  font-weight: bold;
  margin-bottom: 0;
`;

const PressDate = styled.p`
  margin: 0;
  text-align: center;
`;

const PressButton = styled.div`
  padding: 8px 16px;
  border-radius: 10px;
  background-color: ${COLOR_GREEN};
  color: ${COLOR_WHITE};
  font-weight: bold;
`;

const PressTextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 64px;
  flex-direction: column;
`;

const ActionText = styled.p`
  font-weight: bold;
`;

const ActionButton = styled.a`
  height: 49px;
  line-height: 49px;
  padding: 0 16px;
  border-radius: 10px;
  background-color: ${COLOR_GREEN};
  color: ${COLOR_WHITE};
  font-weight: bold;
  text-decoration: none;
`;

const Press = () => {
  const [list, _setList] = useState<PressInterface[]>([]);
  const [openModal, _setOpenModal] = useState<PressInterface | null>(null);

  const getList = async () => {
    const pressRef = query(collection(db, PRESS_COLLECTION), orderBy("rank"));
    const pressSnap = await getDocs(pressRef);

    const pressList: PressInterface[] = [];
    pressSnap.forEach((doc) => {
      const data = doc.data();

      pressList.push({
        id: doc.id,
        title: data.title,
        cover: data.cover,
        date: data.date.toDate(),
        magazine: data.magazine,
        magazineLogo: data.magazineLogo,
        pageUrl: data.pageUrl,
        rank: data.rank,
      });
    });

    _setList(pressList);
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <Wrapper>
      {openModal && (
        <ModalSlideshow
          images={[openModal.pageUrl, openModal.cover]}
          index={0}
          _setOpenModal={() => _setOpenModal(null)}
          fitHeight={true}
        />
      )}
      <Title>Communiqués de presse</Title>
      <GridContainer>
        {list.map((pressItem) => (
          <PressArea key={pressItem.id}>
            <PressItem onClick={() => _setOpenModal(pressItem)}>
              <PressLogo logo={pressItem.magazineLogo}></PressLogo>
              <PressText>{pressItem.title}</PressText>
              <PressTextArea>
                <PressButton>Voir</PressButton>
                <PressDate>
                  Parution le {monthString(pressItem.date.getMonth())}{" "}
                  {pressItem.date.getFullYear()}
                </PressDate>
              </PressTextArea>
            </PressItem>
          </PressArea>
        ))}
      </GridContainer>
      <ActionContainer>
        <ActionText>Vous souhaitez nous contacter ?</ActionText>
        <ActionButton href={CONTACT}>Contactez-nous</ActionButton>
      </ActionContainer>
    </Wrapper>
  );
};

export default Press;
